const fonts = {
  heading: "Canal",
  body: "Canal",
};

export default fonts;
